(function() {
    'use strict';

    angular
        .module('tmgApp')
        .controller('SfrFileDialogController', SfrFileDialogController);

    SfrFileDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'DataUtils', 'entity', 'SfrFile'];

    function SfrFileDialogController ($timeout, $scope, $stateParams, $uibModalInstance, DataUtils, entity, SfrFile) {
        var vm = this;

        vm.sfrFile = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.byteSize = DataUtils.byteSize;
        vm.openFile = DataUtils.openFile;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sfrFile.id !== null) {
                SfrFile.update(vm.sfrFile, onSaveSuccess, onSaveError);
            } else {
                SfrFile.save(vm.sfrFile, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('tmgApp:sfrFileUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.date = false;

        vm.setFile = function ($file, sfrFile) {
            if ($file) {
                DataUtils.toBase64($file, function(base64Data) {
                    $scope.$apply(function() {
                    	sfrFile.fileName = $file.name;
                        sfrFile.file = base64Data;
                        sfrFile.fileContentType = $file.type;
                    });
                });
            }
        };

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();
